import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import { IQbrDocumentInitiative } from 'partner360/models/qbr/iQbrDocumentInitiative'

export const fetchAvailableInitiatives = async (
  documentId: number
): Promise<IQbrDocumentInitiative[]> => {
  const url = proxy(`/webservice/197/sp/v4/spJBPQBRKeyInitiatives/call`)

  const payload = {
    'p.DocumentID': documentId,
  }

  const {
    app: { ownerId },
  } = appGetState()
  const [accessToken] = getTokens(ownerId)

  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  try {
    const response = await Rest.post({ url, payload, headers })

    return response.Data
  } catch (e) {
    return []
  }
}
